<template>
  <IncidentDetails />
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import IncidentDetails from "@/modules/PhishTitan/views/Common/Incidents/IncidentSummary/Details/index.ts";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { t } = useI18n();

pageMetaStore.setPageTitle({
  title: t("incident-summary"),
});
</script>
